import "./FxeQuizResultsComponent.scss";
import {QuestionResult} from "../FxeQuizQuestions";
import {ComponentCallback} from "../../../types/AngularJS";
import {IHttpService, IOnInit} from "angular";
import {AnswerResult, QuizScore} from "../service/models/QuizScore";
import {StringKeyed} from "../../../types/GenericTypes";
import { UserConfig } from "../../../types/UserConfig";

export const FxeQuizResults = "tfFxeQuizResults";

export function fxeQuizResults() {
    return {
        templateUrl: "app/quiz/fxe/results/FxeQuizResultsComponent.html",
        bindings: {
            answers: "<",
            onScoreCalculated: "&",
            onComplete: "&",
            onRetry: "&"
        },
        controllerAs: "ctrl",
        controller: FxeQuizResultsComponentController
    };
}

export class FxeQuizResultsComponentController implements IOnInit {

    private readonly isMfaEnabled: boolean;
    private readonly securitySetting: string;
    public answers: Array<QuestionResult>;
    public onScoreCalculated: ComponentCallback;
    public onComplete: ComponentCallback;
    public onRetry: ComponentCallback;

    public passed = false;
    public correctCount = 0;
    public totalQuestions = 0;
    public score: string;

    public $onInit(): void {
        this.calculateScore();
    }

    /** @ngInject */
    public constructor(private readonly userConfig: UserConfig,
                       private readonly $http: IHttpService) {
        this.isMfaEnabled = userConfig.isMfaEnabled;
        this.securitySetting = userConfig.securitySetting;
    }

    private calculateScore() {
        const totalQuestions = this.answers.length;
        const numCorrect = this.answers.filter(res => res.correct).length;
        const percentage = (numCorrect / totalQuestions) * 100;
        this.passed = percentage >= 66.6;

        this.correctCount = numCorrect;
        this.totalQuestions = totalQuestions;
        this.score = percentage.toFixed(0);

        const answers = this.buildAnswerMap(this.answers);

        const result: QuizScore = {
            passed: this.passed,
            score: +this.score,
            answers
        };
        this.onScoreCalculated({score: result});
    }

    private buildAnswerMap(results: Array<QuestionResult>): StringKeyed<AnswerResult> {
        return results.map(res => this.buildAnswerResult(res))
                      .reduce((acc, next) => Object.assign(acc, next), {});
    }

    private buildAnswerResult(result: QuestionResult): StringKeyed<AnswerResult> {
        const name = result.question.name;
        const answer = {
            answer: String(result.answer),
            correct: result.correct
        };
        return {
            [name]: answer
        };
    }

    public async setupMfa() {
        // NOTE: Fxe is only applicable for TF skin with backOffice PHillip
        window.location.assign("/tradefloor/oauth2/authorization/tf?promptMfa=true");
    }
}
